const activateTab = (buttons, panels, name, buttonAttribute, panelAttribute) => {
    buttons.forEach((button) => {
        const active = button.getAttribute(buttonAttribute) === name;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
        panel.hidden = panel.getAttribute(panelAttribute) !== name;
    });
};

const setupKeyboardNavigation = (container, buttons, activate) => {
    container.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        const direction = event.key === "ArrowRight" ? 1 : -1;
        const next = buttons[(current + direction + buttons.length) % buttons.length];
        next.focus();
        activate(next);
    });
};

export const setupInvoiceWorkspace = () => {
    const workspace = document.querySelector("[data-invoice-workspace]");
    if (!workspace || workspace.dataset.invoiceWorkspaceReady === "true") return;
    workspace.dataset.invoiceWorkspaceReady = "true";

    const pageTabsRoot = workspace.querySelector("[data-invoice-tabs]");
    const pageTabs = [...(pageTabsRoot?.querySelectorAll("[data-invoice-tab]") || [])];
    const pagePanels = [...workspace.querySelectorAll("[data-invoice-panel]")];
    const showPageTab = (button) => {
        const name = button.dataset.invoiceTab;
        activateTab(pageTabs, pagePanels, name, "data-invoice-tab", "data-invoice-panel");
        history.replaceState(null, "", name === "preview" ? "#preview" : "#invoice-details");
    };
    pageTabs.forEach((button) => button.addEventListener("click", () => showPageTab(button)));
    if (pageTabsRoot) setupKeyboardNavigation(pageTabsRoot, pageTabs, showPageTab);

    const requestedTab = window.location.hash === "#preview" ? "preview" : "details";
    activateTab(pageTabs, pagePanels, requestedTab, "data-invoice-tab", "data-invoice-panel");

    const themeDialog = document.getElementById("invoice-document-theme-dialog");
    const themeTabsRoot = themeDialog?.querySelector(".rcd-document-theme-tabs");
    const themeTabs = [...(themeTabsRoot?.querySelectorAll("[data-document-theme-tab]") || [])];
    const themePanels = [...(themeDialog?.querySelectorAll("[data-document-theme-panel]") || [])];
    const showThemeTab = (button) => activateTab(
        themeTabs,
        themePanels,
        button.dataset.documentThemeTab,
        "data-document-theme-tab",
        "data-document-theme-panel");
    themeTabs.forEach((button) => button.addEventListener("click", () => showThemeTab(button)));
    if (themeTabsRoot) setupKeyboardNavigation(themeTabsRoot, themeTabs, showThemeTab);
};
